<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
};
</script>

<template>
  <content-loader
    width="425"
    height="296"
    viewBox="0 0 425 296"
    :speed="2"
    primaryColor="#f8efe688"
    secondaryColor="#f8efe655"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <rect x="46" y="23" width="71" height="39" rx="4" fill="#C4C4C4" />
    <rect x="146" y="23" width="234" height="122" rx="4" fill="#C4C4C4" />
    <rect x="146" y="154" width="234" height="122" rx="4" fill="#C4C4C4" />
    <rect x="46" y="89" width="71" height="39" rx="4" fill="#C4C4C4" />
    <rect x="46" y="155" width="71" height="39" rx="4" fill="#C4C4C4" />
    <rect x="46" y="221" width="72" height="40" rx="4" fill="#C4C4C4" />
    <rect x="45" y="67" width="72" height="9" rx="4" fill="#C4C4C4" />
    <rect x="46" y="133" width="71" height="9" rx="4" fill="#C4C4C4" />
    <rect x="46" y="199" width="71" height="9" rx="4" fill="#C4C4C4" />
    <rect x="46" y="265" width="72" height="9" rx="4" fill="#C4C4C4" />
  </content-loader>
</template>
